import React from 'react';
import { Link } from 'react-router-dom';
import PharmWealthLogo from './PharmWealthLogo';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    products: [
      { path: '/premium-milk', label: 'Premium Milk' },
      { path: '/pharmapp', label: 'PharmApp' },
    ],
    company: [
      { path: '/', label: 'About Us' },
      { path: '/investors', label: 'Investors' },
      { path: '/contact', label: 'Contact' },
    ],
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <PharmWealthLogo size="compact" showText={false} />
            <p className="footer-tagline">
              Ethics Meets Excellence in Dairy & Beyond
            </p>
            <p className="footer-cert">
              FSSAI & APEDA Certified | Zero Antibiotic Residue | Hand-Milked
            </p>
          </div>

          <div className="footer-section">
            <h4>Products</h4>
            <ul>
              {footerLinks.products.map((link) => (
                <li key={link.path}>
                  <Link to={link.path}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-section">
            <h4>Company</h4>
            <ul>
              {footerLinks.company.map((link) => (
                <li key={link.path}>
                  <Link to={link.path}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-section">
            <h4>Connect</h4>
            <ul>
              <li>
                <a href="mailto:info@pharmwealth.com">info@pharmwealth.com</a>
              </li>
              <li>
                <a href="tel:+911234567890">+91 123 456 7890</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="gold-line"></div>
          <p>&copy; {currentYear} PharmWealth Ventures. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

